import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "./roomCategory.css";

const RoomCategory = props => {
	return (
		<div className="room-category">
			<div className={props.roomCategoryVisible ? "room-category-visible" : "room-category-hidden"}>
				<div className="holderBottom"></div>
				<span className="background-clicker" onClick={() => props.setRoomCategoryVisible(false)} />
				<div className="room-category-container">
					{/* <input type="button" value="x" className="btn-back" onClick={() => props.setRoomCategoryVisible(false)} /> */}
					<button
						className="btn-selection"
						onClick={() => {
							props.setIsRoomJoin(true);
							props.setMatchSettingVisible(true);
						}}
					>
						Join Board
					</button>
					<button
						className="btn-selection"
						onClick={() => {
							props.setIsRoomJoin(false);
							props.setMatchSettingVisible(true);
						}}
					>
						Create Board
					</button>
				</div>
			</div>
		</div>
	);
};

export default RoomCategory;
